import thunkMiddleware from 'redux-thunk';

import collectionPageUrlUpdater from './collectionPageUrlUpdater';
import crashReporter from './crashReporter';
import dynamicYieldContextUpdater from './dynamicYieldContextUpdater';
import elementFocuser from './elementFocuser';
import eventBus from './eventBus';
import eventTracker from './eventTracker';
import pdpUrlUpdater from './pdpUrlUpdater';
import setCartCache from './setCartCache';
import setDynamicYieldCookies from './setDynamicYieldCookies';
import setInferredUserCountryCookie from './setInferredUserCountryCookie';
import setSchemaMarkup from './setSchemaMarkup';
import setUserSelectedShopAndRedirect from './setUserSelectedShopAndRedirect';
import titleUpdater from './titleUpdater';

// Build array of middlewares (crash reporter first, thunk last)
const middlewares = [
  crashReporter,
  eventTracker,
  eventBus,
  pdpUrlUpdater,
  collectionPageUrlUpdater,
  elementFocuser,
  titleUpdater,
  setInferredUserCountryCookie,
  setUserSelectedShopAndRedirect,
  dynamicYieldContextUpdater,
  setDynamicYieldCookies,
  setCartCache,
  setSchemaMarkup,
  thunkMiddleware,
];

export default middlewares;
